import {v4 as uuidv4} from 'uuid';

export const getUuid = (): string => uuidv4()
export const priceConvert = (n: any): number => {
    if (typeof n !== 'number') {
        if (isNaN(Number(n))) {
            return 0
        }
    }

    return n / 100
}

export const IsDev = () => {

    if (!process || !process.env.NODE_ENV) {
        return false
    }

    return process.env.NODE_ENV === 'development'
}


export interface UserStorage {
    expire: string,
    token: string,
    customerMobile: string,
    id: string,
    sex?:number,
    statusCode: number,
    avatarUrl?:string,
    fullName?:string,
    idNumber?:string,
    nickName?:string,
    birthday?:string,
    photo?:string,
    stars?:number,
    certified:boolean,
    referee?:boolean,
    region?:number,
    createTime:number
}

type UserStorageType = UserStorage | null

export const getUserStorage = (): UserStorageType => {
    const data = localStorage.getItem('userData');

    if (!data) {
        return null
    }

    return JSON.parse(data)
}

export const saveUserStorage = (data: UserStorage): void => {
    localStorage.setItem('userData', JSON.stringify(data))
}

export const setUserStorage = <T extends keyof UserStorage>(key: T, value: any): void => {
    const data = getUserStorage();
    if (data) {
        data[key] = value
        saveUserStorage(data)
    }
}


export const flatObj = <T>(obj:object,overlap:boolean = true,target:object = {}):T => {
    const result = target
    for (let [k,v] of Object.entries(obj)){
        if(k in result && !overlap){
            continue
        }

        if(Object.prototype.toString.call(v) === '[object Object]'){
            flatObj(v,overlap,result)
        }else{
            // @ts-ignore
            result[k] = v
        }

    }
    return (result as any);
}

export const getPlatform = () => {
    return IsDev() ? 'dev' : 'prod'
}

export const addZero = (n:number) => {
    const s = n.toString()
    return s.length > 1 ? s : '0' + s
}

export const dateFormat = (n:number | Date | string,join = '-',format = ['year','month','date'],detail = false):string => {
    if(typeof n === 'string' ){
        return n;
    }else{
        const _date = typeof n === 'number' ? new Date(n) : n;
        const year = _date.getFullYear()
        const month = _date.getMonth() + 1
        const date = _date.getDate()
        const hours = _date.getHours()
        const minutes = _date.getMinutes()
        const seconds = _date.getSeconds()
        const returns = { year, month, date }
        // @ts-ignore
        let times = format.map(item => addZero(returns[item])).join(join)

        if(detail){
            return times + ' '+ [hours,minutes,seconds].map(item => addZero(item)).join(':')
        }
        // @ts-ignore
        return times
    }

}

export const getObjectURL = (file:File) => {
    let url = null;
    // @ts-ignore
    if (window.createObjectURL !== undefined) {
        // @ts-ignore
        url = window.createObjectURL(file);
    } else if (window.URL !== undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
    } else if (window.webkitURL !== undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
    }
    return url;
}

export const getPhoneName = (user:UserStorage) :string => {
    if(user.fullName){
        return user.fullName
    }else{
        return `用户#${ user.customerMobile.slice(-4) }`
    }
}

export const sexTsf = (n:string|number|null|undefined) => {
    if(n === null || n === undefined){
        return '未知'
    }
    let sex = n;
    const names = ['保密','男士', '女士'];
    if(typeof sex === 'string'){
        sex = Number(sex)
    }
    return names[sex]
}

export const nounTsf = (n:string | number | undefined,len = 4) => {
    if(!n) return '';
    const s = String(n)
    return s.length > len ? s : s.padStart(len,'0')
}

export const httpReg = (n:string) => {
    if(!n){
        return false
    }

    return /[a-zA-z]+:\/\/[^\s]*/.test(n)
}

export const newsTime = (data:any) => {
    if(data){
        if(data.releaseTime){
            return (data.releaseTime as string).split(' ')[0]
        }else{
            return dateFormat(data.createTime)
        }
    }

    return null
}

// console.log(process.env.NODE_ENV === 'development')

export const getAdsID = () : null | string => {
    return window.localStorage.getItem('ads-id')
}

export const setAdsID = (str:string | null) => {
    if (str) {
        window.localStorage.setItem('ads-id', str)
    } else {
        window.localStorage.removeItem('ads-id')
    }
}

export const delay = (callback:Function,delayTime:number) => {
   setTimeout(callback,delayTime)
}
